import React from 'react';
import { FadeIn } from './FadeIn';
import { PiggyBank, PackageOpen, Zap, RefreshCw } from 'lucide-react';
export function PorQueElegir() {
  const reasons = [{
    icon: <PiggyBank className="w-8 h-8 text-brand-gold" data-id="element-500" />,
    title: 'Ahorras dinero',
    desc: 'Compra ambos cursos pagando menos.'
  }, {
    icon: <PackageOpen className="w-8 h-8 text-brand-gold" data-id="element-501" />,
    title: 'Todo incluido',
    desc: 'Cursos + Bonos Premium.'
  }, {
    icon: <Zap className="w-8 h-8 text-brand-gold" data-id="element-502" />,
    title: 'Acceso inmediato',
    desc: 'Empieza inmediatamente después del pago.'
  }, {
    icon: <RefreshCw className="w-8 h-8 text-brand-gold" data-id="element-503" />,
    title: 'Actualizaciones futuras',
    desc: 'Recibe nuevas mejoras sin pagar nuevamente.'
  }];
  return <section className="bg-white py-20 md:py-32 px-4 sm:px-6" data-id="element-504">
      <div className="max-w-6xl mx-auto" data-id="element-505">
        <FadeIn data-id="element-506">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green text-center mb-16 tracking-tight" data-id="element-507">
            ¿Por qué elegir el Sistema Completo?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-508">
          {reasons.map((r, i) => <FadeIn key={i} delay={0.1 * i} data-id="element-509">
              <div className="bg-brand-beige/20 rounded-3xl p-8 sm:p-10 border border-brand-text/5 text-center h-full hover:shadow-lg transition-shadow duration-300" data-id="element-510">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white shadow-sm mb-6" data-id="element-511">
                  {r.icon}
                </div>
                <h3 className="text-xl font-bold text-brand-green mb-3" data-id="element-512">
                  {r.title}
                </h3>
                <p className="text-brand-text/70" data-id="element-513">{r.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}